import React from "react";
import styled from "styled-components";

const TopServiceBanner = (props) => {
  return (
    <Container>
      <ImgContainer>
        <BannerImg
          className="top-service-banner-img"
          src={props.banner}
          alt="banner"
        />
      </ImgContainer>
      <SvgContainer>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#ff3946"
          fill-opacity="1"
          d="M0,256L60,245.3C120,235,240,213,360,208C480,203,600,213,720,202.7C840,192,960,160,1080,128C1200,96,1320,64,1380,48L1440,32L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
        ></path>
      </svg>
        {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#ff3946"
            fill-opacity="1"
            d="M0,192L288,224L576,96L864,256L1152,320L1440,32L1440,0L1152,0L864,0L576,0L288,0L0,0Z"
          ></path>
        </svg> */}
        <MainHeading>{props.title}</MainHeading>
      </SvgContainer>
    </Container>
  );
};

export default TopServiceBanner;

const ImgContainer = styled.div`
  border-top: 0.7rem solid white;
`;

const BannerImg = styled.img`
  width: 100%;
  height: 20rem;
`;

const SvgContainer = styled.div`
  position: relative;
`;

const MainHeading = styled.h1`
  font-size: 4rem;
  color: white;
  position: absolute;
  top: 5%;
  left: 3%;

  @media (max-width: 1000px) {
    font-size: 3rem;
  }
  @media (max-width: 650px) {
    font-size: 2rem;
  }
  @media (max-width: 450px) {
    font-size: 1.5rem;
  }
`;

const Container = styled.div`
  border-top: 2rem solid var(--color-red);
`;
